import { useEffect } from 'react';

const useHash = <Hash extends string = string>(callback: (hash: Hash) => void): void => {
  useEffect(() => {
    const hash = window.location.hash.replace('#', '') as Hash | undefined;
    if (hash) {
      callback(hash);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useHash;
